module.exports = __webpack_public_path__ + "2050828fe2da9b71979543bbda93b801.ttf";